import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";
import { PermissionToExtendStart, PermissionToExtendDeny, UnderwriterPermissionToExtendPageInformation, UnderwriterPermissionToExtendTemplate } from "interfaces/Mueller.Business.Models";

export const isInPermissionToExtendWorkflow = (controlNumber: number, successCallback: (isInWorkflow: boolean) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/due-date-extend/${controlNumber}/permission`,
  successCallback,
  errorCallback,
  mountedRef
});

export const getPermissionToExtendTemplates = (controlNumber: number, successCallback: (templates: UnderwriterPermissionToExtendTemplate) => void, errorCallback: () => void, mountedRef: Ref<boolean>)  => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/due-date-extend/${controlNumber}/permission-email-templates`,
  successCallback,
  errorCallback,
  mountedRef
});

export const requestPermissionToExtend = (controlNumber: number, payload: PermissionToExtendStart, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/due-date-extend/${controlNumber}/permission`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const cancelPermissionToExtend = (controlNumber: number, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/due-date-extend/${controlNumber}/permission`,
  successCallback,
  errorCallback,
  mountedRef
});

export const getPermissionToExtendPageInfo = (workItemId: string, successCallback: (data: UnderwriterPermissionToExtendPageInformation) => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/due-date-extend/${workItemId}/permission-submit`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const approvePermissionToExtend = (workItemId: string, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/due-date-extend/${workItemId}/permission-submit/approve`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const denyPermissionToExtend = (workItemId: string, payload: PermissionToExtendDeny, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/due-date-extend/${workItemId}/permission-submit/deny`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
